import { useState } from "react";

export default (defaultShow = false) => {
  const [show, setShow] = useState(defaultShow);
  const toggleModal = () => setShow(!show);

  return { show, toggleModal };
};
